import React, { useState } from 'react';
import { Colors } from "./colors";
import { withTranslation } from 'react-i18next';
import styled from "@emotion/styled";


function LanguageToggle({t, i18n}) {
  const [language, setLanguage] = useState(localStorage.getItem("ratib_language") || 'ar');

  const toggleLanguage = () => {
    setLanguage((prevLanguage) => {
      const newLanguage = prevLanguage === 'en' ?  'ar' : 'en';
      i18n.changeLanguage(newLanguage.toLowerCase());
      localStorage.setItem("ratib_language", newLanguage.toLowerCase());
      return newLanguage;
    });
  };

  return (
    <LinkWrapper onClick={toggleLanguage}>
      {language.toLowerCase() == 'en' ? 'عربي' : 'EN'}
    </LinkWrapper>
  );
}

export default withTranslation()(LanguageToggle);

const LinkWrapper = styled.div`
  text-align: center;
  display: inline-block;
  padding: 8px;
  border-radius: 8px;
  background-color: ${Colors.spaceGray}; /* Change to your preferred background color */
  color: #fff; /* Change to your preferred text color */
  text-decoration: none;
  cursor: pointer;
  transition:
    background-color 0.3s,
    color 0.3s;

  &:hover {
    background-color: ${Colors.charcolGrey}; /* Change to your preferred hover background color */
    color: #fff; /* Change to your preferred hover text color */
  }
`;